import { createServerFn } from "@tanstack/react-start";
import { getAuthContext } from "@/lib/services";
import { getUserSettings, updateUserSettings } from "@/db/user";
import { SUPPORTED_CURRENCIES } from "@/lib/constants";

export const loadSettings = createServerFn({ method: "GET" }).handler(async () => {
  const { db, userId } = await getAuthContext();
  const settings = await getUserSettings(db, userId);
  return { defaultCurrency: settings.default_currency };
});

export const updateSettingsFn = createServerFn({ method: "POST" })
  .inputValidator((data: { defaultCurrency: string }) => data)
  .handler(async ({ data }) => {
    const { db, userId } = await getAuthContext();

    if (!(SUPPORTED_CURRENCIES as readonly string[]).includes(data.defaultCurrency)) {
      throw new Error(`Unsupported currency: ${data.defaultCurrency}`);
    }

    await updateUserSettings(db, userId, data.defaultCurrency);
  });
